module.exports = __webpack_public_path__ + "static/hive-c306a00fad3dd1b7110d7f73df61d931.svg";